import { Button } from '#app/components/Buttons/Button.js';
import { css, styled } from 'styled-components';

export const ContraProText = styled.p`
  background: linear-gradient(
    90deg,
    #61a6f2 1.56%,
    #8f6fdb 23.44%,
    #ff5a5e 53.12%,
    #f2c94c 80%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  margin-bottom: 8px;
`;

export const AccessTypeLayout = styled.div`
  padding: 16px;
  display: grid;
  gap: 8px;
`;

export const AccessTypeLabel = styled.span`
  font-size: 12px;
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.semiBold};
    color: ${theme.colorsV2.gray80};
  `};
`;

export const AccessTypePromotion = styled.span`
  font-size: 10px;
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray60};
  `};
`;

export const LabelAndPromo = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 8px;
`;

export const AccessTypeValues = styled.div`
  display: flex;
  margin-top: 2px;
`;

export const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  line-height: 0;

  width: 56px;
  justify-content: space-around;
`;

export const StyledButton = styled(Button).attrs({
  size: 'xsmall',
  variant: 'V2TertiaryOutline',
})`
  font-size: 14px;
`;

export const Grid = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(1, 240px);
    & > div {
      margin-bottom: 8px;
      padding-bottom: 16px;
      border-bottom: 1px solid ${theme.colorsV2.gray40};
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
    }
  `}
`;
